import {api} from './api'
import {ApiResponse, Transaction} from '../types'

export const getTransactions = async (limit: number = 100, offset: number = 0): Promise<Transaction[]> => {
    try {
        const response = await api.get<ApiResponse<Transaction[]>>(`/api/transactions/filter?limit=${limit}&offset=${offset}`)
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching transactions:', error)
        return []
    }
}

export const getTransaction = async (id: number): Promise<Transaction | null> => {
    try {
        const response = await api.get<ApiResponse<Transaction>>(`/api/transactions/${id}`)
        return response.data.data || null
    } catch (error) {
        console.error('Error fetching transaction:', error)
        return null
    }
}

export const buy = async (phone: string, amount: number, walletPhone: string): Promise<any> => {
    try {
        const response = await api.post('/sync', {
            phone,
            amount: amount.toString(),
            type: 'BUY',
            walletPhone
        })
        return response.data
    } catch (error) {
        console.error('Buy error:', error)
        throw error
    }
}

export const sell = async (phone: string, amount: number, walletPhone: string): Promise<any> => {
    try {
        const response = await api.post('/sync', {
            phone,
            amount: amount.toString(),
            type: 'SELL',
            walletPhone
        })
        return response.data
    } catch (error) {
        console.error('Sell error:', error)
        throw error
    }
}

export const filterTransactions = async (params: {
    type?: 'BUY' | 'SELL',
    userId?: string,
    operator?: 'alfa' | 'touch',
    startDate?: string,
    endDate?: string,
    limit?: number
}): Promise<Transaction[]> => {
    try {
        const queryParams = new URLSearchParams()
        if (params.type) queryParams.append('type', params.type)
        if (params.userId) queryParams.append('userId', params.userId)
        if (params.operator) queryParams.append('operator', params.operator)
        if (params.startDate) queryParams.append('startDate', params.startDate)
        if (params.endDate) queryParams.append('endDate', params.endDate)
        if (params.limit) queryParams.append('limit', params.limit.toString())

        const response = await api.get(`/api/transactions/filter?${queryParams.toString()}`)
        return response.data.data || []
    } catch (error) {
        console.error('Error filtering transactions:', error)
        return []
    }
}